<template>
  <v-card v-if="responseData !== null">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="40"></v-progress-circular>
    </v-overlay>
    <!-- <v-card-title>{{ roleName }}</v-card-title> -->
    <v-card-title class="d-flex justify-space-between p-0 m-0">
      <div class="ps-2 headingFontsize">Role: {{ roleName }}</div>
      <div>
        <bread-crumb :bread-crumbs="['Collection Limit']" />
      </div>
    </v-card-title>
    <v-divider class="p-0 mt-1 mb-0 primary--text"></v-divider>
    <v-card-text>
      <v-card
        v-if="!responseData.length"
        height="300px"
        class="d-flex align-items-center justify-center"
      >
        <div>
          <div class="text-center"><v-icon>mdi mdi-reload</v-icon></div>
          <h5>No Data Available</h5>
        </div>
      </v-card>
      <v-container>
        <v-card
          class="mb-5"
          v-for="(item, index) in responseData"
          :key="index"
          width="1200px"
        >
          <v-card-title class="pa-1">
            <div class="row top10px">
              <div class="col-md-5 my-auto primary--text ps-4">
                <b class="ps-4">{{ item.module_name }}</b>
              </div>
              <div class="col-md-7 my-auto">
                <div>
                  <v-chip outlined dense class="ma-2 pa-2">
                    <v-checkbox
                      v-model="responseData[index]['is_view']"
                      @change="selectAll(responseData[index])"
                      label="Select All"
                    ></v-checkbox>
                  </v-chip>
                </div>
              </div>
            </div>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-divider></v-divider>
            <div
              class="row"
              v-for="(subItem, index1) in item.permissions"
              :key="index1"
            >
              <p
                class="col-md-4 m-auto font-weight-bold"
                style="padding-left: 50px"
              >
                {{ subItem.sub_module_name }}
              </p>
              <div class="col-md-8 my-auto">
                <v-chip outlined class="ma-2"
                  ><v-checkbox
                    flat
                    v-model="
                      responseData[index]['permissions'][index1]['is_view']
                    "
                    color="info"
                    label="View"
                  ></v-checkbox
                ></v-chip>
                <v-chip outlined class="ma-2"
                  ><v-checkbox
                    flat
                    v-model="
                      responseData[index]['permissions'][index1]['is_create']
                    "
                    color="info"
                    label="Add"
                  ></v-checkbox
                ></v-chip>

                <v-chip outlined class="ma-2"
                  ><v-checkbox
                    flat
                    v-model="
                      responseData[index]['permissions'][index1]['is_update']
                    "
                    color="info"
                    label="Edit"
                  ></v-checkbox
                ></v-chip>

                <v-chip outlined class="ma-2"
                  ><v-checkbox
                    flat
                    v-model="
                      responseData[index]['permissions'][index1]['is_delete']
                    "
                    color="info"
                    label="Delete"
                  ></v-checkbox
                ></v-chip>
                <v-chip outlined class="ma-2"
                  ><v-checkbox
                    flat
                    v-model="
                      responseData[index]['permissions'][index1][
                        'is_approve_reject'
                      ]
                    "
                    color="info"
                    label="Approve & Reject"
                  ></v-checkbox
                ></v-chip>
              </div>
            </div>
          </v-card-text> </v-card
      ></v-container>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col class="mb-4">
          <v-btn
            class="float-right"
            depressed
            color="primary "
            @click="updatePermissions()"
          >
            <v-icon small class="me-2">mdi-content-save-edit-outline</v-icon>
            Update Permissions
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
// import axios from "axios";
import alerts from "@/mixins/alerts";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  props: ["roleCode", "roleName", "roleId"],
  data() {
    return {
      // hideUpdatebtn: false,
      overlay: false,
      currentRoleData: {
        expiry_date: "20-12-2000",
        description: "Complaince role",
      },
      role_permissions: ["View", "Edit", "Approve & Reject", "Delete", "Add"],
      responseData: [],
    };
  },
  computed: {
    datepickerEnable() {
      if (this.EnableExpiryDatePicker === false) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.getRoleById(this.roleId);
    // this.getPermissionDetails(this.roleId);
  },
  methods: {
    selectAll(data) {
      console.log("selected data", data);
      this.responseData = this.responseData.map((ele) => {
        console.log("selected data ele", ele);
        if (ele.module_name === data.module_name) {
          ele.permissions = ele.permissions.map((ele) => {
            if (data.is_view) {
              ele.is_view = true;
              ele.is_update = true;
              ele.is_delete = true;
              ele.is_create = true;
              ele.is_approve_reject = true;
            } else {
              ele.is_view = false;
              ele.is_update = false;
              ele.is_delete = false;
              ele.is_create = false;
              ele.is_approve_reject = false;
            }
            return ele;
          });
          return ele;
        } else {
          return ele;
        }
      });
    },
    async updatePermissions() {
      console.log(this.responseData);
      // console.log("updated response", this.responseData);
      // axios
      //   .post(
      //     `${process.env.VUE_APP_BASEURL}:8005/api/v1/permissions/give_permissions_data`,
      //     this.responseData,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
      //         accept: "application/json",
      //       },
      //       params: {
      //         role_name: this.roleName,
      //       },
      //     }
      //   )
      //   .then((responseData) => {
      //     console.log("update permissions response", responseData);
      //     this.$router.push("/RolesList");
      //   });
      this.overlay = true;
      try {
        const response = await userService.updateSubModulesByRole(
          this.roleId,
          this.responseData
        );
        if (response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.getRoleById(this.roleId);
          this.overlay = false;
        } else {
          this.showAlertError(`Failed: ${response.data.message}`);
          this.overlay = false;
        }
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.overlay = false;
      }
    },
    // getPermissionDetails(role_id) {
    //   console.log("role id", role_id);
    //   this.overlay = true;
    //   axios
    //     .get(
    //       `${process.env.VUE_APP_BASEURL}:8005/api/v1/permissions/get_permission/` +
    //         role_id,
    //       {
    //         headers: {
    //           "Content-Type": "application/json",
    //           Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
    //           accept: "application/json",
    //         },
    //       }
    //     )
    //     .then((responseData) => {
    //       this.responseData = responseData.data.data;
    //       console.log("responseData roles list", this.responseData);
    //       this.overlay = false;
    //     });
    // },
    async getRoleById(id) {
      // axios
      //   .get(
      //     `${process.env.VUE_APP_BASEURL}:8005/api/v1/roles/get_role/` + id,
      //     {
      //       headers: {
      //         "Content-Type": "application/json",
      //         Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
      //         accept: "application/json",
      //       },
      //     }
      //   )
      //   .then((responseData) => {
      // this.currentRoleData = responseData.data.data[0];
      //     console.log("roles by id", this.currentRoleData);
      //   });
      this.overlay = true;
      try {
        const response = await userService.getSubModulesByRole(id);
        if (response.data.status_code == 200) {
          this.responseData = response.data.data;
        }
        console.log("Roles", response);
        this.overlay = false;
      } catch (e) {
        console.error(e);
        this.showAlertError("Something went wrong please try again later.");
        this.overlay = false;
      }
    },
    // getRoleDate(code) {
    //   return axios.get(
    //     `${process.env.VUE_APP_BASEURL}:8005/api/v1/roles/get_role_data/` +
    //       code,
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${sessionStorage.getItem("__ac_mn_tk")}`,
    //         accept: "application/json",
    //       },
    //     }
    //   );
    // },
    colorByStatus(mainIndex, type) {
      if (type === "is_view") {
        let atleastOneValueTrue = this.responseData[mainIndex][
          "permissions"
        ].some((element) => element["is_view"] === true);
        console.log("atleastOneValueTrue", atleastOneValueTrue);

        let allTrue = this.responseData[mainIndex]["permissions"].every(
          (element) => element["is_view"] === true
        );
        console.log("allTrue", allTrue);
        if (atleastOneValueTrue === true && allTrue === true) {
          this.responseData[mainIndex]["is_view"] = true;
          console.log("warning returned");
          return "success";
        } else if (atleastOneValueTrue === true && allTrue === false) {
          this.responseData[mainIndex]["is_view"] = true;
          return "warning";
        }
      }
      if (type === "is_update") {
        let atleastOneValueTrue = this.responseData[mainIndex][
          "permissions"
        ].some((element) => element["is_update"] === true);
        console.log("atleastOneValueTrue", atleastOneValueTrue);

        let allTrue = this.responseData[mainIndex]["permissions"].every(
          (element) => element["is_update"] === true
        );
        console.log("allTrue", allTrue);
        if (atleastOneValueTrue === true && allTrue === true) {
          this.responseData[mainIndex]["is_update"] = true;
          console.log("warning returned");
          return "success";
        } else if (atleastOneValueTrue === true && allTrue === false) {
          this.responseData[mainIndex]["is_update"] = true;
          return "warning";
        }
      }
      if (type === "is_approve_reject") {
        let atleastOneValueTrue = this.responseData[mainIndex][
          "permissions"
        ].some((element) => element["is_approve_reject"] === true);
        console.log("atleastOneValueTrue", atleastOneValueTrue);

        let allTrue = this.responseData[mainIndex]["permissions"].every(
          (element) => element["is_approve_reject"] === true
        );
        console.log("allTrue", allTrue);
        if (atleastOneValueTrue === true && allTrue === true) {
          this.responseData[mainIndex]["is_approve_reject"] = true;
          console.log("warning returned");
          return "success";
        } else if (atleastOneValueTrue === true && allTrue === false) {
          this.responseData[mainIndex]["is_approve_reject"] = true;
          return "warning";
        }
      }
      if (type === "is_delete") {
        let atleastOneValueTrue = this.responseData[mainIndex][
          "permissions"
        ].some((element) => element["is_delete"] === true);
        console.log("atleastOneValueTrue", atleastOneValueTrue);

        let allTrue = this.responseData[mainIndex]["permissions"].every(
          (element) => element["is_delete"] === true
        );
        console.log("allTrue", allTrue);
        if (atleastOneValueTrue === true && allTrue === true) {
          this.responseData[mainIndex]["is_delete"] = true;
          console.log("warning returned");
          return "success";
        } else if (atleastOneValueTrue === true && allTrue === false) {
          this.responseData[mainIndex]["is_delete"] = true;
          return "warning";
        }
      }
      if (type === "is_create") {
        let atleastOneValueTrue = this.responseData[mainIndex][
          "permissions"
        ].some((element) => element["is_create"] === true);
        console.log("atleastOneValueTrue", atleastOneValueTrue);

        let allTrue = this.responseData[mainIndex]["permissions"].every(
          (element) => element["is_create"] === true
        );
        console.log("allTrue", allTrue);
        if (atleastOneValueTrue === true && allTrue === true) {
          this.responseData[mainIndex]["is_create"] = true;
          console.log("warning returned");
          return "success";
        } else if (atleastOneValueTrue === true && allTrue === false) {
          this.responseData[mainIndex]["is_create"] = true;
          return "warning";
        }
      }
    },
    giveAllViewAccess(index, checkValue) {
      if (checkValue === true) {
        this.responseData[index]["is_view"] = true;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_view"] = true;
        });
      } else if (checkValue === false) {
        this.responseData[index]["is_view"] = false;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_view"] = false;
        });
      }
    },
    giveAllEditAccess(index, checkValue) {
      if (checkValue === true) {
        this.responseData[index]["is_update"] = true;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_update"] = true;
        });
      } else if (checkValue === false) {
        this.responseData[index]["is_update"] = false;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_update"] = false;
        });
      }
    },
    giveAllApproveAndRejectAccess(index, checkValue) {
      if (checkValue === true) {
        this.responseData[index]["is_approve_reject"] = true;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_approve_reject"] = true;
        });
      } else if (checkValue === false) {
        this.responseData[index]["is_approve_reject"] = false;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_approve_reject"] = false;
        });
      }
    },
    giveAllDeleteAccess(index, checkValue) {
      if (checkValue === true) {
        this.responseData[index]["is_delete"] = true;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_delete"] = true;
        });
      } else if (checkValue === false) {
        this.responseData[index]["is_delete"] = false;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_delete"] = false;
        });
      }
    },
    giveAllUpdateStatusAccess(index, checkValue) {
      if (checkValue === true) {
        this.responseData[index]["is_create"] = true;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_create"] = true;
        });
      } else if (checkValue === false) {
        this.responseData[index]["is_create"] = false;
        this.responseData[index]["permissions"].forEach((element) => {
          element["is_create"] = false;
        });
      }
    },
    subPermissionView(mainIndex) {
      let atleastOneValueTrue = this.responseData[mainIndex][
        "permissions"
      ].some((element) => element["is_view"] === true);
      if (atleastOneValueTrue === true) {
        this.responseData[mainIndex]["is_view"] = true;
      } else {
        this.responseData[mainIndex]["is_view"] = false;
      }
      let allTrue = this.responseData[mainIndex]["permissions"].every(
        (element) => element["is_view"] === true
      );
      if (allTrue === true) {
        this.responseData[mainIndex]["is_view"] = true;
      }
    },
    subPermissionEdit(mainIndex) {
      let atleastOneValueTrue = this.responseData[mainIndex][
        "permissions"
      ].some((element) => element["is_update"] === true);
      if (atleastOneValueTrue === true) {
        this.responseData[mainIndex]["is_update"] = true;
      } else {
        this.responseData[mainIndex]["is_update"] = false;
      }
      let allTrue = this.responseData[mainIndex]["permissions"].every(
        (element) => element["is_update"] === true
      );
      if (allTrue === true) {
        this.responseData[mainIndex]["is_update"] = true;
      }
    },
    subPermissionApproveAndReject(mainIndex) {
      let atleastOneValueTrue = this.responseData[mainIndex][
        "permissions"
      ].some((element) => element["is_approve_reject"] === true);
      if (atleastOneValueTrue === true) {
        this.responseData[mainIndex]["is_approve_reject"] = true;
      } else {
        this.responseData[mainIndex]["is_approve_reject"] = false;
      }
      let allTrue = this.responseData[mainIndex]["permissions"].every(
        (element) => element["is_approve_reject"] === true
      );
      if (allTrue === true) {
        this.responseData[mainIndex]["is_approve_reject"] = true;
      }
    },
    subPermissionDelete(mainIndex) {
      let atleastOneValueTrue = this.responseData[mainIndex][
        "permissions"
      ].some((element) => element["is_delete"] === true);
      if (atleastOneValueTrue === true) {
        this.responseData[mainIndex]["is_delete"] = true;
      } else {
        this.responseData[mainIndex]["is_delete"] = false;
      }
      let allTrue = this.responseData[mainIndex]["permissions"].every(
        (element) => element["is_delete"] === true
      );
      if (allTrue === true) {
        this.responseData[mainIndex]["is_delete"] = true;
      }
    },
    subPermissionUpdateStatus(mainIndex) {
      let atleastOneValueTrue = this.responseData[mainIndex][
        "permissions"
      ].some((element) => element["is_create"] === true);
      if (atleastOneValueTrue === true) {
        this.responseData[mainIndex]["is_create"] = true;
      } else {
        this.responseData[mainIndex]["is_create"] = false;
      }
      let allTrue = this.responseData[mainIndex]["permissions"].every(
        (element) => element["is_create"] === true
      );
      if (allTrue === true) {
        this.responseData[mainIndex]["is_create"] = true;
      }
    },
  },
};
</script>

<style>
.margin-y {
  margin-top: auto;
  margin-bottom: auto;
}
.full-height {
  height: 100vh;
}
ul {
  list-style: none;
}

li {
  display: inline;
}
.dot {
  height: 15px;
  width: 15px;

  border-radius: 50%;
  display: inline-block;
}

.v-label {
  /* top: 5px; */
  margin-right: 20px;
}
.v-input--selection-controls.v-input {
  pointer-events: All;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.v-label {
  margin-top: auto;
  margin-bottom: auto;
}
.top10px {
  top: 10px;
  position: relative;
}
</style>
